import '@/assets/scss/custom.scss';

// icons: https://github.com/FortAwesome/vue-fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import {
	faCaretRight,
	faCheck,
	faFileAlt,
	faFileArchive,
	faFileAudio,
	faFileCode,
	faFileCsv,
	faFileExcel,
	faFileImage,
	faFilePdf,
	faFilePowerpoint,
	faFileVideo,
	faFileWord,
	faMobileAlt,
	faTimes
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// bootstrap: https://bootstrap-vue.org/docs
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Vue from 'vue';

import App from './App';
import router from './router';
import store from './store';
library.add(
	faCheckCircle,
	faCheck,
	faCaretRight,
	faTimes,
	faFileWord,
	faFileExcel,
	faFileCsv,
	faFileArchive,
	faFileAlt,
	faFileImage,
	faFileCode,
	faFilePowerpoint,
	faFilePdf,
	faFileVideo,
	faFileAudio,
	faMobileAlt
);
Vue.component(`FAIcon`, FontAwesomeIcon);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.config.productionTip = false;

// eslint-disable-next-line no-undef
window.COMPILED = process.env.NODE_ENV === `production`;
// eslint-disable-next-line no-undef
window.QA = !window.location.href.includes(`cloud.precisionplanting.com`);

new Vue({ router, store, render: h => h(App) }).$mount(`#app`);